import { Storage, Auth } from 'aws-amplify';
// My Components
import config from '../config';

export async function s3Upload(file) {
  const filename = `${Date.now()}-${file.name}`;

  // 1st, upload the img
  // TODO: make sure it's an admin ???
  // TODO check with SS people
  const { key = null } = await Storage.vault.put(filename, file, {
    contentType: file.type,
  });

  // 2nd, determine path to img (url)
  const { identityId: userIdentityId = null } = await Auth.currentUserCredentials();
  const { BUCKET: s3Bucket } = config.s3;
  const haveAllUrlInfo = key !== null && userIdentityId !== null;

  const urlPattern = `https://${s3Bucket}.s3.amazonaws.com/private/${userIdentityId}/${key}`;

  return {
    key,
    fullImgUrl: haveAllUrlInfo ? urlPattern : '',
  };
}
